<template>
  <div v-cloak class="fixedViewDialog">
    <el-dialog
      v-cloak
      top="20vh"
      :close-on-click-modal="false"
      :visible.sync="fixedViewDialog"
      width="580px"
      :before-close="handleClose"
      :lock-scroll="false"
    >
      <div class="img-content">
        <!-- <img src="../../img/kuaio_popup_1012.gif" alt="" /> -->
        <img src="https://oss.fjdaze.com/tools/dzPopup/Images/kuaio_popup_1112.gif" alt="" />
        <div @click="closeBtnFUC" class="closeBtn"></div>
        <div @click="closeIconFUC" class="closeIcon">
          <img src="https://oss.fjdaze.com/tools/dzPopup/Images/delete.png" alt="" />
        </div>
      </div>
    </el-dialog>
    <div v-if="isIllegalWord" @click.prevent="openFixedInto" class="fiex-right-bottom">
      <img src="https://oss.fjdaze.com/tools/dzPopup/Images/kuai_right_1112.gif" alt="" />
      <!-- <img src="../../img/kuai_right_1012.gif" alt="" /> -->
      <div class="closeGift" @click.stop="closeGiftFunc"></div>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie, delCookie } from "../../../../../plugins/cookie";
export default {
  data() {
    return {
      fixedViewDialog: false,
      isIllegalWord: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.$nextTick(() => {
      this.isIllegalWord = this.isShowGif();
      this.open();
    });
  },
  mounted() {},
  computed: {},
  methods: {
    closeGiftFunc() {
      this.isIllegalWord = false;
      sessionStorage.setItem("rightbottomGift", "true");
    },
    isShowGif() {
      let boolean;
      location.href.indexOf("/illegalWord") > -1 ? (boolean = true) : (boolean = false);
      let status = sessionStorage.getItem("rightbottomGift") == "true" ? false : true;
      boolean = boolean && status;
      return boolean;
    },
    openFixedInto() {
      _hmt.push(["_trackEvent", "1688产品检测", "·悬浮标立即抢购·点击"]);
      this.$router.push({ path: "/buy" });
    },
    handleClose(done) {
      sessionStorage.setItem("fixedViewDialog", "true");
      done();
      this.fixedViewDialog = false;
      if (!this.$checkLogin()) return;
      this.$router.push({ path: "/buy" });
    },
    closeBtnFUC() {
      this.fixedViewDialog = false;
      sessionStorage.setItem("fixedViewDialog", "true");
      this.$router.push({ path: "/buy" });
      _hmt.push(["_trackEvent", "1688产品检测", "·弹窗立即抢购·点击"]);
    },
    closeIconFUC() {
      sessionStorage.setItem("fixedViewDialog", "true");
      this.fixedViewDialog = false;
    },
    open() {
      let fixedViewDialog = sessionStorage.getItem("fixedViewDialog");
      if (fixedViewDialog == "true") {
        this.fixedViewDialog = false;
      } else {
        this.fixedViewDialog = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fiex-right-bottom {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 200px;
  height: 200px;
  cursor: pointer;
  // background: url("https://oss.fjdaze.com/aliProject/images/fixedRightBottom.gif");
  img {
    width: 100%;
    display: inline-block;
  }
  .closeGift {
    position: absolute;
    right: 0;
    top: 0;
    width: 30px;
    height: 30px;
    z-index: 20;
  }
}
.fixedViewDialog {
  .img-content {
    position: relative;
    height: 460px;
    // background: url("./img/dialog_bg.gif") center center;
    img {
      display: inline-block;
      width: 100%;
    }
    .closeBtn {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 92px;
      width: 230px;
      height: 80px;
      z-index: 88;
      // background: red;
      cursor: pointer;
    }
    .closeIcon {
      position: absolute;
      top: -28px;
      right: -28px;
      width: 28px;
      height: 28px;
      z-index: 88;
      // background: red;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.fixedViewDialog {
  .el-dialog__wrapper {
    .el-dialog {
      background: none;
      box-shadow: none;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
<style type="text/css">
[v-cloak] {
  display: none !important;
}
</style>
